import { injectGlobal } from "react-emotion"

import avenir from "assets/fonts/avenir-next.otf"
import avenirDemi from "assets/fonts/avenir-next-demi.otf"
import sharpSansMedium from "assets/fonts/SHSNMedium.ttf"
import sharpSansBold from "assets/fonts/SHSN.ttf"

injectGlobal`
@font-face {
    font-family: "Avenir-Next";
    src: url(${avenir});
    font-weight: normal;
}

@font-face {
    font-family: "Avenir-Next";
    src: url(${avenirDemi});
    font-weight: bold;
}
@font-face {
    font-family: "Sharp-Sans";
    src: url(${sharpSansMedium});
    font-weight: medium;
}
@font-face {
    font-family: "Sharp-Sans";
    src: url(${sharpSansBold});
    font-weight: bold;
}

a {
    text-decoration: none;
    color: #2980b9;
}

#app {    height: 100vh;
}
`



// WEBPACK FOOTER //
// ./src/ui/styleHelpers/globalStyles.js